import type { PropsWithChildren } from "react";
import type { ContextValue } from "./NotesContext";
import { NotesContext } from "./NotesContext";

export const NotesContextProvider = ({
  entityId,
  entityType,
  objectType,
  hasPermissionsToManageNotes,
  children,
}: PropsWithChildren<ContextValue>) => (
  <NotesContext value={{ entityId, entityType, objectType, hasPermissionsToManageNotes }}>{children}</NotesContext>
);
